export default "__VITE_ASSET__B3gyKULu__"